/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#getPageHeight__anchor
 */
export default pageNumber => window.documentViewer.getPageHeight(pageNumber);
